import React from 'react';
import { BsArrowRight } from 'react-icons/bs';

function ContactItem({ icon, heading, text, item1, item2, link }) {
    return (
        <div className="col-lg-3 col-md-6 col-12 d-flex">
            <div
                className="single-contact-card card1"
                onClick={() => window.open(link, '_blank', 'noopener,noreferrer')}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && window.open(link, '_blank', 'noopener,noreferrer')}
            >
                <div className="top-part">
                    <div className="icon">{icon}</div>
                    <div className="title">
                        <h4>{heading}</h4>
                    </div>
                </div>
                <div className="bottom-part">
                    <div className="info">
                        <p>{item1}</p>
                        <p>{item2}</p>
                    </div>
                </div>
                <div className="icon">
                    <BsArrowRight />
                </div>
            </div>
        </div>
    );
}

export default ContactItem;
